import {
  FundSubscriptionForm,
  Section,
  SubscriptionTable,
} from '@/components/molecules'
import { useCancelSubscription, useFundSubscription } from '@/hooks'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { formatEther } from 'viem'
import { useAccount, useBalance } from 'wagmi'

export const ManageSingleSubscription = ({
  subscription,
  showLoading: isLoadingSub,
  refetchSub,
}) => {
  const navigate = useNavigate()
  const { address } = useAccount()
  const { data: balance, isLoading: isLoadingBalance } = useBalance({ address })
  const [showFund, setShowFund] = useState(false)
  const subId = subscription?.subId
  const { submit: submitCancelSubscription, isSuccess: isSuccessCancelSub } =
    useCancelSubscription()
  const { submit: submitFundSubscription, isSuccess: isSuccessFundSub } =
    useFundSubscription()

  const subscriptionActions = [
    {
      action: () => {
        setShowFund(true)
      },
      text: 'Fund Subscription',
    },
    {
      action: () => {
        submitCancelSubscription({ subId })
      },
      text: 'Cancel Subscription',
    },
  ]

  const handleSubmitFundSub = ({ amount }) => {
    if (!amount || !subId) return

    submitFundSubscription({ amount, subId })
  }

  useEffect(() => {
    if (isSuccessFundSub || isSuccessCancelSub) {
      refetchSub()
    }
  }, [isSuccessFundSub, isSuccessCancelSub, refetchSub])

  useEffect(() => {
    if (isSuccessCancelSub) {
      setTimeout(() => {
        navigate('/subscriptions')
      }, 1500)
    }
  }, [isSuccessCancelSub, navigate])

  return (
    <Section
      alignItems={'stretch'}
      title="Subscription"
      actions={subscriptionActions}
      isLoading={isLoadingSub}
    >
      {showFund && (
        <FundSubscriptionForm
          onSubmit={handleSubmitFundSub}
          setShowFund={setShowFund}
          ftnBalance={
            isLoadingBalance || !balance ? 0 : formatEther(balance.value)
          }
        />
      )}

      <SubscriptionTable isLoading={isLoadingSub} subscription={subscription} />
    </Section>
  )
}
